<template>

  <div class="abort-state-wrapper">
  <div class="two-column-layout">
    <div class="column-left">
      <h3>{{headline}}</h3>
      <p v-html="message" />
      <button
          @click="workflowStore.sendWorkflowEvent({ type: 'BACK' })"
          class="button button_ghost">
        Zurück
      </button>
    </div>
    <div class="column-right right-image">
      <img :src="imageSrc" class="ast_image" aria-hidden="true" alt="" />
    </div>
  </div>
  <AbortTeaser :teaserCards="teaserCards"/>
  </div>
</template>

<script>
import AbortTeaser from '@/components/AbortTeaser.vue';
import defaultImage from '../../assets/absage.jpg'
import {useWorkflowStore} from '@/stores/workflow';


export default {
  name: 'AbortStateTemplate',
  components: {
    AbortTeaser
  },
  setup() {
    const workflowStore = useWorkflowStore();
    return {
      workflowStore
    };
  },
  props: {
    headline: {
      type: String,
      default: "Vielen Dank für Ihr Interesse. Leider können wir kein Angebot für das Haus erstellen."
    },
    message: {
      type: String,
      required: true
    },
    imageSrc: {
      type: String,
      default: defaultImage  // <- automatisch gesetzte Bundler-URL
    },
    teaserCards: {
      type: Array,
      required: true
    }
  },
};
</script>

<style scoped>

#app-ves-clickstream h3{
  text-align: left !important;
  margin: auto;
}
#app-ves-clickstream .two-column-layout {
  display: grid;
  gap: 40px;
  text-align: left !important;
}


#app-ves-clickstream .ast_image{
  max-width: 100%;

  max-height: 500px;

  height: auto;
}

@media (min-width: 768px) {
  #app-ves-clickstream .two-column-layout {
    grid-template-columns: 1fr 1fr;
  }

  #app-ves-clickstream .column-left {
    margin-right: 30px;
  }
}

@media (max-width: 767px){
  #app-ves-clickstream .right-image {
    display:none;
  }
}

@media (min-width: 800px) {
  #app-ves-clickstream .column-right {
    text-align: right;
  }
}
</style>